export const replaceAll = (str: string | null | undefined, find: string, replace: string) => {
  return (str || "").replace(new RegExp(find, 'g'), replace);
};
